module.exports = __webpack_public_path__ + "img/loan-icon.91a409e5.svg";